import Q, { useCallback as oe, useState as P, useMemo as U, useEffect as L, useRef as re } from "react";
import { jsx as e, jsxs as s, Fragment as Be } from "react/jsx-runtime";
import { Tag as v, Collapse as he, Card as W, Button as B, Typography as H, Select as ve, Space as $, Row as Je, Col as Me, Input as G, Badge as ge, Tooltip as X, Switch as xe, Statistic as Le, Table as Oe, Alert as se, App as Te, Divider as ue, theme as Pe, Segmented as Xe, Descriptions as q } from "antd";
import { LinkOutlined as $e, CopyOutlined as pe, ReloadOutlined as ie, CloudOutlined as Ue } from "@ant-design/icons";
import { useGlobalStore as Y } from "@digiwedge/global-state";
import { useLogin as _e } from "@digiwedge/hooks-auth-web";
import { jwtDecode as We } from "jwt-decode";
import { setTeeTimeBaseUrl as Re, diagnoseIpLocation as He } from "@digiwedge/teetime-api-client";
function _(t) {
  const n = String(t || "").trim();
  return n ? n.replace(/\/$/, "") : "";
}
async function Ke(t, n) {
  try {
    const o = await fetch(t, {
      headers: { accept: "application/json" },
      cache: "no-store",
      ...n || {}
    });
    try {
      const i = await o.json();
      return { ok: o.ok, status: o.status, data: i };
    } catch {
      return { ok: o.ok, status: o.status };
    }
  } catch {
    return { ok: !1, status: 0 };
  }
}
async function De(t, n, o) {
  const i = (t || "").replace(/\/$/, "");
  let p = { ok: !1, status: 0, urlTried: `${i}${n[0]}` };
  for (const c of n) {
    const u = `${i}${c}`, y = await Ke(u, o);
    if (p = { ok: y.ok, status: y.status, urlTried: u, data: y.data }, y.ok)
      return p;
  }
  return p;
}
function Ve(t, n) {
  const o = oe(() => {
    try {
      const y = localStorage.getItem(t);
      return y ? JSON.parse(y) : n;
    } catch {
      return n;
    }
  }, [t, n]), [i, p] = P(() => o()), c = oe(
    (y) => {
      p(y);
      try {
        localStorage.setItem(t, JSON.stringify(y));
      } catch {
      }
    },
    [t]
  );
  return U(() => ({ overrides: i, setOverrides: c }), [i, c]);
}
function qe({ ok: t }) {
  return /* @__PURE__ */ e(v, { color: t ? "green" : "red", children: t ? "OK" : "DOWN" });
}
function Ne({ sections: t }) {
  return t?.length ? /* @__PURE__ */ e(
    he,
    {
      defaultActiveKey: [],
      size: "small",
      items: t.map((n) => ({
        key: n.key,
        label: n.header,
        children: /* @__PURE__ */ e("pre", { style: { whiteSpace: "pre-wrap" }, children: JSON.stringify(n.data ?? {}, null, 2) })
      }))
    }
  ) : null;
}
function xt({
  title: t,
  url: n,
  base: o,
  paths: i,
  request: p,
  showDetails: c
}) {
  const [u, y] = P(!1), [h, m] = P(null), f = oe(async () => {
    y(!0);
    try {
      let x;
      if (p)
        x = await p();
      else if (n) {
        const g = await fetch(n, { headers: { accept: "application/json" }, cache: "no-store" });
        try {
          const w = await g.json();
          x = { ok: g.ok, status: g.status, urlTried: n, data: w };
        } catch {
          x = { ok: g.ok, status: g.status, urlTried: n };
        }
      } else o && i && i.length ? x = await De(o, i) : x = { ok: !1 };
      m(x);
    } finally {
      y(!1);
    }
  }, [n, o, i, p]);
  L(() => {
    f().catch(() => {
    });
  }, [f]);
  const D = !!(h && "ok" in h && h.ok), O = h && ((x) => typeof x == "object" && x !== null && "data" in x)(h) ? h.data : void 0;
  return /* @__PURE__ */ s(
    W,
    {
      title: t,
      extra: /* @__PURE__ */ e(B, { onClick: f, loading: u, children: "Retry" }),
      children: [
        /* @__PURE__ */ e(qe, { ok: D }),
        c && O ? /* @__PURE__ */ e("div", { style: { marginTop: 8 }, children: /* @__PURE__ */ e(Ne, { sections: [{ key: "json", header: `${t} — JSON`, data: O }] }) }) : null
      ]
    }
  );
}
const { Text: Ge } = H;
function Tt({
  metaName: t = "idp-audience",
  options: n,
  defaultValue: o,
  applyLabel: i = "Apply & Reload",
  onApplied: p,
  reload: c,
  value: u,
  onValueChange: y
}) {
  let h = "";
  try {
    h = document.querySelector(`meta[name="${t}"]`)?.content?.trim() || "";
  } catch {
  }
  const m = o || h || "", f = u !== void 0, [D, I] = P(m), O = f ? u : D, x = re(O);
  x.current !== O && (x.current = O), L(() => {
    if (f) return;
    const S = o || h || "";
    S !== x.current && (x.current = S, I(S));
  }, [o, h, f]), L(() => {
    if (f || n.some((F) => F.value === x.current)) return;
    const S = n[0]?.value ?? "";
    S !== x.current && (x.current = S, I(S));
  }, [f, n]);
  const g = U(
    () => O || o || h || "",
    [o, h, O]
  ), w = (S) => {
    x.current = S, f || I(S), y?.(S);
  };
  return /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ e(Ge, { strong: !0, children: "Audience" }),
    /* @__PURE__ */ s("div", { style: { display: "flex", gap: 8, marginTop: 4 }, children: [
      /* @__PURE__ */ e(
        ve,
        {
          "aria-label": "Audience",
          value: O,
          style: { minWidth: 220 },
          options: n,
          onChange: (S) => {
            const F = String(S ?? "");
            w(F);
          }
        }
      ),
      /* @__PURE__ */ e(B, { "aria-label": "Apply and reload", onClick: () => {
        const S = x.current;
        try {
          let j = document.querySelector(`meta[name="${t}"]`);
          j || (j = document.createElement("meta"), j.setAttribute("name", t), document.head.appendChild(j)), j.setAttribute("content", S);
        } catch {
        }
        p?.(S), (c ?? window.location.reload?.bind(window.location))?.();
      }, children: i })
    ] }),
    /* @__PURE__ */ s($, { size: "small", style: { marginTop: 4 }, children: [
      /* @__PURE__ */ s(v, { color: "blue", children: [
        "effective: ",
        g || "not set"
      ] }),
      h ? /* @__PURE__ */ s(v, { color: "purple", children: [
        "meta: ",
        h
      ] }) : /* @__PURE__ */ e(v, { children: "env/default" })
    ] })
  ] });
}
const { Text: Ae } = H;
function St({
  storageKey: t,
  env: n,
  fields: o,
  onOverridesChange: i,
  columns: p = { xs: 24, md: 12, lg: 8 }
}) {
  const { overrides: c, setOverrides: u } = Ve(
    t,
    {}
  ), y = (h, m) => {
    const f = { ...c, [h]: m || void 0 };
    u(f), i?.(f);
  };
  return /* @__PURE__ */ e(Je, { gutter: [16, 16], children: o.map((h) => {
    const m = h.effective ? h.effective(c, n) : String(c[h.key] ?? n[h.key] ?? "");
    return /* @__PURE__ */ s(Me, { xs: p.xs, md: p.md, lg: p.lg, children: [
      /* @__PURE__ */ e(Ae, { strong: !0, children: h.label }),
      /* @__PURE__ */ e(
        G,
        {
          "aria-label": h.label,
          placeholder: h.placeholder,
          value: c[h.key] ?? "",
          onChange: (f) => y(h.key, f.target.value)
        }
      ),
      /* @__PURE__ */ s(Ae, { type: "secondary", children: [
        "effective: ",
        m || "not set"
      ] })
    ] }, h.key);
  }) });
}
const { Title: Ye, Text: te } = H;
function Ct({
  title: t = "Probes",
  specs: n,
  autoRefreshDefaultMs: o = 3e4
}) {
  const [i, p] = P([]), [c, u] = P(null), [y, h] = P(!1), [m, f] = P(o), [D, I] = P(null), [O, x] = P(0), g = re(null), w = re(null), N = re(y), S = oe(async () => {
    const a = n.map(async (R) => {
      const b = R.base === "__SAME_ORIGIN__", E = b ? "" : R.base;
      if (!E && !b)
        return { name: R.name, baseUrl: "", status: "skip" };
      const z = await De(E, R.candidates), l = z;
      return {
        name: R.name,
        baseUrl: b ? "(same-origin)" : _(E),
        status: z.ok ? "ok" : z.status === 503 ? "degraded" : "fail",
        endpointTried: "urlTried" in z ? z.urlTried : void 0,
        statusCode: "status" in z ? z.status : void 0,
        ms: typeof l.ms == "number" ? l.ms : void 0,
        url: "urlTried" in z ? z.urlTried : void 0
      };
    }), k = await Promise.all(a);
    p(k), u(Date.now());
  }, [n]);
  L(() => {
    S().catch(() => {
    });
  }, [S]), L(() => {
    N.current = y;
  }, [y]), L(() => {
    const a = () => {
      g.current && (window.clearTimeout(g.current), g.current = null), w.current && (window.clearInterval(w.current), w.current = null);
    };
    if (!y) {
      a(), I(null), x(0);
      return;
    }
    const k = () => {
      const R = Date.now() + m;
      I(R), g.current = window.setTimeout(async () => {
        g.current = null, await S(), N.current && k();
      }, m);
    };
    return k(), () => {
      a();
    };
  }, [y, m, S]), L(() => {
    if (!(!y || !D))
      return w.current && window.clearInterval(w.current), w.current = window.setInterval(() => {
        const a = Math.max(0, Math.round((D - Date.now()) / 1e3));
        x(a);
      }, 300), () => {
        w.current && (window.clearInterval(w.current), w.current = null);
      };
  }, [y, D]);
  const F = U(() => {
    const a = i.some((b) => b.status === "fail"), k = i.some((b) => b.status === "degraded"), R = i.some((b) => b.status === "ok");
    return a ? "fail" : k ? "degraded" : R ? "ok" : "skip";
  }, [i]), j = async (a) => {
    try {
      await navigator.clipboard.writeText(a);
    } catch {
    }
  }, T = (a) => {
    const k = Math.max(0, Date.now() - a), R = Math.round(k / 1e3);
    if (R < 60) return `${R}s ago`;
    const b = Math.floor(R / 60);
    if (b < 60) return `${b}m ago`;
    const E = Math.floor(b / 60);
    return E < 24 ? `${E}h ago` : `${Math.floor(E / 24)}d ago`;
  }, r = i.map((a, k) => {
    const R = a.url || a.endpointTried || "", b = typeof a.statusCode == "number" ? String(a.statusCode) : "n/a", E = /* @__PURE__ */ e(
      ge,
      {
        status: a.status === "ok" ? "success" : a.status === "degraded" ? "warning" : a.status === "fail" ? "error" : "default",
        text: b
      }
    ), z = (() => {
      const l = [], A = R || a.baseUrl;
      return A && (l.push(
        /* @__PURE__ */ e(X, { title: "Open", children: /* @__PURE__ */ e("a", { href: A, target: "_blank", rel: "noreferrer", "aria-label": "Open probe", children: /* @__PURE__ */ e($e, {}) }) }, "open")
      ), l.push(
        /* @__PURE__ */ e(X, { title: "Copy", children: /* @__PURE__ */ e(
          B,
          {
            type: "text",
            "aria-label": "Copy probe",
            icon: /* @__PURE__ */ e(pe, {}),
            onClick: () => j(A)
          }
        ) }, "copy")
      )), l;
    })();
    return {
      key: String(k),
      name: a.name,
      base: a.baseUrl || "not set",
      endpoint: R || "—",
      status: E,
      network: a.statusCode === 0 ? "network/CORS" : "",
      latency: typeof a.ms == "number" ? `${a.ms} ms` : "—",
      actions: z
    };
  }), d = [
    {
      title: "Probe",
      dataIndex: "name",
      key: "name",
      render: (a) => /* @__PURE__ */ e($, { size: 4, children: /* @__PURE__ */ e(Ye, { level: 5, style: { margin: 0 }, children: a }) })
    },
    {
      title: "Base",
      dataIndex: "base",
      key: "base",
      render: (a) => /* @__PURE__ */ e("code", { children: a })
    },
    {
      title: "Endpoint",
      dataIndex: "endpoint",
      key: "endpoint",
      render: (a) => /* @__PURE__ */ e("code", { children: a })
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status"
    },
    {
      title: "Details",
      key: "network",
      render: (a, k) => /* @__PURE__ */ s($, { size: 8, wrap: !0, children: [
        k.network ? /* @__PURE__ */ e(te, { type: "warning", children: k.network }) : null,
        /* @__PURE__ */ e(Qe, { label: "latency", value: k.latency })
      ] })
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (a) => /* @__PURE__ */ e($, { children: a })
    }
  ];
  return /* @__PURE__ */ s(
    W,
    {
      title: t,
      extra: /* @__PURE__ */ e(B, { icon: /* @__PURE__ */ e(ie, {}), onClick: () => S(), children: "Refresh" }),
      children: [
        /* @__PURE__ */ s($, { style: { marginBottom: 8 }, children: [
          /* @__PURE__ */ e(
            ge,
            {
              status: F === "ok" ? "success" : F === "fail" ? "error" : "default",
              text: `Aggregate: ${F.toUpperCase()}`
            }
          ),
          c && /* @__PURE__ */ e(X, { title: new Date(c).toString(), children: /* @__PURE__ */ s(te, { type: "secondary", children: [
            "Checked at ",
            new Date(c).toLocaleTimeString(),
            " (",
            T(c),
            ")"
          ] }) }),
          /* @__PURE__ */ s($, { children: [
            /* @__PURE__ */ e(te, { children: "Auto-refresh" }),
            /* @__PURE__ */ e(xe, { checked: y, onChange: h })
          ] }),
          /* @__PURE__ */ s($, { children: [
            /* @__PURE__ */ e(te, { children: "Every" }),
            /* @__PURE__ */ e(
              ve,
              {
                size: "small",
                value: m,
                style: { width: 90 },
                onChange: (a) => f(Number(a)),
                options: [
                  { value: 15e3, label: "15s" },
                  { value: 3e4, label: "30s" },
                  { value: 6e4, label: "60s" }
                ]
              }
            )
          ] }),
          /* @__PURE__ */ s($, { children: [
            /* @__PURE__ */ e(te, { type: "secondary", children: "Next in" }),
            D ? /* @__PURE__ */ e(Le, { value: O, suffix: "s", styles: { content: { fontSize: 14 } } }) : /* @__PURE__ */ e(ge, { status: "default", text: "Auto: OFF" })
          ] })
        ] }),
        /* @__PURE__ */ e(
          Oe,
          {
            size: "small",
            dataSource: r,
            columns: d,
            pagination: !1,
            rowKey: "key"
          }
        )
      ]
    }
  );
}
function Qe({ label: t, value: n }) {
  return /* @__PURE__ */ s(
    "span",
    {
      style: {
        display: "inline-flex",
        gap: 6,
        alignItems: "center",
        paddingInline: 6,
        paddingBlock: 2,
        borderRadius: 6,
        background: "rgba(0,0,0,0.04)"
      },
      children: [
        /* @__PURE__ */ e(te, { type: "secondary", children: t }),
        /* @__PURE__ */ e("code", { children: n })
      ]
    }
  );
}
const { Title: Ze, Text: Ie } = H, et = "XSRF-TOKEN=";
function we() {
  return typeof document > "u" ? !1 : document.cookie.split(";").map((t) => t.trim()).some((t) => t.startsWith(et));
}
function tt(t) {
  const {
    title: n = "Route Access Diagnostics",
    routes: o,
    auth: i,
    tenants: p,
    loadTenants: c,
    checkCapability: u,
    resolveRoute: y
  } = t, [h, m] = P([]), [f, D] = P(!1), [I, O] = P(null), [x, g] = P(p || []), [w, N] = P(void 0), [S, F] = P(() => we());
  L(() => {
    !p && c && (async () => {
      try {
        const r = await c();
        g(Array.isArray(r) ? r : []), Array.isArray(r) && r.length > 0 && !w && N(r[0].id);
      } catch (r) {
        O(r?.message || "Failed to load tenants");
      }
    })();
  }, []);
  const j = oe(async () => {
    D(!0), O(null);
    try {
      const r = [];
      for (const d of o) {
        let a = "—", k = d.protected ? !!i.isAuthenticated : !0, R;
        if (u) {
          const b = await Promise.resolve(u(d, { tenantId: w, token: i.token }));
          a = b.capability, k = typeof b.accessible == "boolean" ? b.accessible : k, R = b.note;
        } else
          a = (d.feature || d.action, "—"), k = d.protected ? !!i.isAuthenticated : !0;
        r.push({
          key: d.path,
          route: d.path,
          feature: d.feature,
          action: d.action,
          protected: !!d.protected,
          capability: a,
          accessible: k,
          note: R
        });
      }
      m(r);
    } catch (r) {
      O(r?.message || "Failed to evaluate routes");
    } finally {
      D(!1);
    }
  }, [i.isAuthenticated, i.token, o, u, w]);
  L(() => {
    j();
  }, [j]), L(() => {
    if (typeof document > "u") return;
    let r = we();
    F(r);
    const d = window.setInterval(() => {
      const a = we();
      a !== r && (F(a), !r && a && j(), r = a);
    }, 2500);
    return () => window.clearInterval(d);
  }, [j]);
  const T = U(
    () => [
      { title: "Route", dataIndex: "route", key: "route" },
      {
        title: "Feature/Action",
        key: "feat",
        render: (r, d) => /* @__PURE__ */ s($, { size: 6, children: [
          d.feature ? /* @__PURE__ */ e(v, { children: d.feature }) : /* @__PURE__ */ e(v, { children: "—" }),
          d.action ? /* @__PURE__ */ e(v, { children: d.action }) : null
        ] })
      },
      {
        title: "Protected",
        dataIndex: "protected",
        key: "protected",
        render: (r) => r ? /* @__PURE__ */ e(v, { color: "blue", children: "Yes" }) : /* @__PURE__ */ e(v, { children: "No" })
      },
      {
        title: "Capability",
        dataIndex: "capability",
        key: "capability",
        render: (r) => r === "Allowed" ? /* @__PURE__ */ e(v, { color: "green", children: "Allowed" }) : r === "Allowed (bypass)" ? /* @__PURE__ */ e(v, { color: "green", children: "Allowed (bypass)" }) : r === "Denied" ? /* @__PURE__ */ e(v, { children: "Denied" }) : /* @__PURE__ */ e(v, { children: "—" })
      },
      {
        title: "Accessible Now",
        dataIndex: "accessible",
        key: "accessible",
        render: (r) => r ? /* @__PURE__ */ e(v, { color: "green", children: "Yes" }) : /* @__PURE__ */ e(v, { children: "No" })
      },
      {
        title: "Open",
        key: "open",
        render: (r, d) => {
          const k = (y || ((E) => ({ ok: !0, url: E.path, missing: [] })))({
            path: d.route,
            label: d.route,
            protected: d.protected,
            feature: d.feature,
            action: d.action
          }), R = !d.accessible || !k.ok, b = d.accessible ? k.ok ? "Open" : `Missing: ${k.missing.join(", ")}` : "Not accessible now (auth/capability)";
          return /* @__PURE__ */ e(X, { title: b, children: /* @__PURE__ */ s("span", { children: [
            /* @__PURE__ */ e(
              B,
              {
                size: "small",
                disabled: R,
                onClick: () => {
                  k.ok && (window.location.href = k.url);
                },
                children: "Open"
              }
            ),
            /* @__PURE__ */ e(
              B,
              {
                size: "small",
                style: { marginLeft: 6 },
                disabled: R,
                onClick: () => {
                  k.ok && window.open(k.url, "_blank");
                },
                children: "New tab"
              }
            )
          ] }) });
        }
      }
    ],
    [y]
  );
  return /* @__PURE__ */ e(
    W,
    {
      style: { marginTop: 16 },
      title: /* @__PURE__ */ e(Ze, { level: 4, style: { margin: 0 }, children: n }),
      children: /* @__PURE__ */ s($, { orientation: "vertical", style: { width: "100%" }, children: [
        /* @__PURE__ */ e(Ie, { type: "secondary", children: "Diagnose authentication and capability gating across routes." }),
        /* @__PURE__ */ s($, { wrap: !0, children: [
          /* @__PURE__ */ s(v, { color: i.isAuthenticated ? "green" : "red", children: [
            "Authenticated: ",
            String(i.isAuthenticated)
          ] }),
          /* @__PURE__ */ s(v, { color: i.token ? "green" : "default", children: [
            "Token: ",
            i.token ? "present" : "missing"
          ] }),
          /* @__PURE__ */ s(v, { color: i.refreshToken ? "green" : "default", children: [
            "Refresh: ",
            i.refreshToken ? "present" : "missing"
          ] }),
          /* @__PURE__ */ s(v, { color: i.jti ? "green" : "default", children: [
            "JTI: ",
            i.jti ? "present" : "missing"
          ] }),
          /* @__PURE__ */ s(v, { color: S ? "green" : "default", children: [
            "CSRF cookie: ",
            S ? "present" : "missing"
          ] }),
          /* @__PURE__ */ e(B, { size: "small", onClick: () => void j(), loading: f, children: "Refresh now" })
        ] }),
        (x?.length || c) && /* @__PURE__ */ s($, { children: [
          /* @__PURE__ */ e(Ie, { type: "secondary", children: "Tenant" }),
          /* @__PURE__ */ e(
            ve,
            {
              size: "small",
              style: { minWidth: 260 },
              value: w,
              placeholder: "none",
              allowClear: !0,
              onChange: (r) => N(r),
              options: (x || []).map((r) => ({ label: r.name, value: r.id }))
            }
          ),
          /* @__PURE__ */ e(B, { size: "small", onClick: () => void j(), loading: f, children: "Run checks" }),
          /* @__PURE__ */ e(
            B,
            {
              size: "small",
              disabled: !h || h.length === 0,
              onClick: async () => {
                try {
                  const r = (h ?? []).map(({ key: d, ...a }) => a);
                  await navigator.clipboard.writeText(JSON.stringify(r, null, 2));
                } catch {
                }
              },
              children: "Copy JSON"
            }
          )
        ] }),
        I && /* @__PURE__ */ e(se, { type: "warning", message: I }),
        /* @__PURE__ */ e(
          Oe,
          {
            size: "small",
            loading: f,
            pagination: { pageSize: 10 },
            rowKey: (r) => r.key,
            columns: T,
            dataSource: h
          }
        )
      ] })
    }
  );
}
function Fe(t, n, o, i) {
  if (!t) return;
  const p = t, c = p.open;
  if (typeof c == "function") {
    c({
      type: n,
      message: o,
      description: i
    });
    return;
  }
  const u = p[n];
  typeof u == "function" && u({
    message: o,
    description: i
  });
}
function je(t, n, o) {
  if (!t) return;
  const i = t, p = i.open;
  if (typeof p == "function") {
    p({ type: n, content: o });
    return;
  }
  const c = i[n];
  typeof c == "function" && c(o);
}
const { Text: ke } = H;
function Z() {
  try {
    if (typeof document > "u") return;
    const t = document.cookie.split(";").map((o) => o.trim()).find((o) => o.startsWith("XSRF-TOKEN="));
    if (!t) return;
    const n = t.slice(11);
    return n ? decodeURIComponent(n) : "";
  } catch {
    return;
  }
}
function nt(t) {
  if (!t) return "—";
  try {
    return new Date(t).toLocaleTimeString();
  } catch {
    return "—";
  }
}
function Rt(t) {
  const { proxyOrigin: n, upstreamBase: o, audience: i = "teetime-admin" } = t, { notification: p } = Te.useApp(), c = (T, r, d) => Fe(p, T, r, d), [u, y] = P(null), [h, m] = P(null), [f, D] = P(!1), [I, O] = P(!1), x = U(() => n ? _(n) : typeof window < "u" ? _(window.location.origin) : "", [n]), g = U(() => _(o || ""), [o]), w = typeof window < "u" && window.location.pathname || "", N = (T, r, d, a) => {
    if (r === 0)
      return {
        severity: "error",
        summary: "No response (status 0)",
        hint: "Proxy unreachable or TLS handshake failed",
        ok: !1
      };
    if (r === 204 && d)
      return {
        severity: "success",
        summary: "204 · XSRF cookie issued",
        ok: !0
      };
    if (r === 204 && !d) {
      const k = w.startsWith("/api/auth") ? "Cookie should be scoped to this host. Check SameSite=None, proxy headers, and TLS." : "This page cannot read cookies scoped to /api/auth; check DevTools → Application → Cookies to confirm.";
      return {
        severity: T === "proxy" ? "warning" : "info",
        summary: "204 · missing XSRF cookie",
        hint: T === "proxy" ? k : "Direct upstream responded but cookie did not persist (third-party cookie policies may block it).",
        ok: T !== "proxy"
      };
    }
    return r === 401 ? {
      severity: "warning",
      summary: "401 · Authentication required",
      hint: "User may need to log in before CSRF endpoint allows access.",
      ok: !1
    } : r === 403 ? {
      severity: "error",
      summary: "403 · CSRF guard blocked request",
      hint: "Cookie/header mismatch. Ensure proxy preserves cookies and X-XSRF-Token header.",
      ok: !1
    } : r >= 200 && r < 300 ? {
      severity: T === "proxy" ? "warning" : "info",
      summary: `${r} · unexpected status`,
      hint: "Expected 204 No Content. Inspect headers for more detail.",
      ok: T !== "proxy"
    } : r >= 500 ? {
      severity: "error",
      summary: `${r} · upstream error`,
      hint: "Upstream IDP returned 5xx. Check proxy target and upstream health.",
      ok: !1
    } : {
      severity: "warning",
      summary: `${r} · unexpected response`,
      hint: "Review headers and body for details.",
      ok: !1
    };
  }, S = async () => {
    D(!0);
    try {
      const T = performance.now(), r = await fetch("/api/auth/csrf", {
        credentials: "include",
        cache: "no-store"
      }), d = Math.round(performance.now() - T), a = [];
      r.headers.forEach((A, C) => {
        a.push([C, A]);
      });
      const R = typeof Z() == "string", { severity: b, summary: E, hint: z, ok: l } = N("proxy", r.status, R);
      y({
        ok: l,
        status: r.status,
        ms: d,
        xsrfPresent: R,
        timestamp: Date.now(),
        severity: b,
        summary: E,
        hint: z,
        headers: a
      }), window.setTimeout(() => {
        typeof Z() == "string" && y(
          (C) => C && {
            ...C,
            xsrfPresent: !0,
            ok: C.ok || C.status === 204
          }
        );
      }, 100), b === "success" && c("success", "Auth proxy responded successfully"), b === "warning" && c("warning", E), b === "error" && c("error", E);
    } catch (T) {
      const r = T?.message || "Network error";
      y({
        ok: !1,
        status: 0,
        ms: 0,
        xsrfPresent: !1,
        timestamp: Date.now(),
        severity: "error",
        summary: "Network failure",
        hint: r
      }), c("error", "Auth proxy check failed", r);
    } finally {
      D(!1);
    }
  }, F = async () => {
    if (g) {
      O(!0);
      try {
        const T = performance.now(), r = await fetch(`${g}/api/auth/csrf`, {
          credentials: "include",
          cache: "no-store"
        }), d = Math.round(performance.now() - T), a = [];
        r.headers.forEach((A, C) => {
          a.push([C, A]);
        });
        const R = typeof Z() == "string", { severity: b, summary: E, hint: z, ok: l } = N("upstream", r.status, R);
        m({
          ok: l,
          status: r.status,
          ms: d,
          xsrfPresent: R,
          timestamp: Date.now(),
          severity: b,
          summary: E,
          hint: z,
          headers: a
        }), window.setTimeout(() => {
          typeof Z() == "string" && m(
            (C) => C && {
              ...C,
              xsrfPresent: !0
            }
          );
        }, 100), b === "success" ? c("success", "Upstream IDP responded successfully") : c(b === "warning" ? "warning" : b === "error" ? "error" : "info", E);
      } catch (T) {
        const r = T?.message || "Network error";
        m({
          ok: !1,
          status: 0,
          ms: 0,
          xsrfPresent: !1,
          timestamp: Date.now(),
          severity: "error",
          summary: "Network failure",
          hint: r
        }), c("error", "Upstream check failed", r);
      } finally {
        O(!1);
      }
    }
  }, j = (T, r) => {
    if (!r) return null;
    const d = r.xsrfPresent ? "present" : "missing", a = /* @__PURE__ */ s($, { orientation: "vertical", size: 4, style: { width: "100%" }, children: [
      /* @__PURE__ */ s($, { wrap: !0, children: [
        /* @__PURE__ */ s(v, { color: r.ok ? "green" : r.severity === "warning" ? "gold" : "red", children: [
          "status: ",
          r.status
        ] }),
        /* @__PURE__ */ e(v, { color: r.ms ? "blue" : void 0, children: r.ms ? `${r.ms} ms` : "timed out" }),
        /* @__PURE__ */ s(v, { color: r.xsrfPresent ? "green" : "default", children: [
          "XSRF cookie: ",
          d
        ] }),
        /* @__PURE__ */ s(v, { children: [
          "checked: ",
          nt(r.timestamp)
        ] })
      ] }),
      /* @__PURE__ */ e(ke, { children: r.summary }),
      r.hint ? /* @__PURE__ */ e(ke, { type: "secondary", children: r.hint }) : null
    ] }), k = r.headers ? [
      {
        key: "headers",
        label: "Response headers",
        extra: /* @__PURE__ */ e(
          B,
          {
            "aria-label": "Copy headers",
            size: "small",
            type: "text",
            icon: /* @__PURE__ */ e(pe, {}),
            onClick: async (R) => {
              R.stopPropagation();
              try {
                await navigator.clipboard.writeText(
                  r.headers?.map(([b, E]) => `${b}: ${E}`).join(`
`) || ""
                ), c("success", "Headers copied to clipboard");
              } catch (b) {
                c("warning", b?.message || "Copy failed");
              }
            }
          }
        ),
        children: /* @__PURE__ */ e("pre", { style: { margin: 0, maxHeight: 200, overflow: "auto" }, children: r.headers.map(([R, b]) => `${R}: ${b}`).join(`
`) || "—" })
      }
    ] : void 0;
    return /* @__PURE__ */ s("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e(se, { type: r.severity, message: T, description: a, showIcon: !0 }),
      k ? /* @__PURE__ */ e(he, { size: "small", style: { marginTop: 8 }, items: k }) : null
    ] }, T);
  };
  return /* @__PURE__ */ s(
    W,
    {
      title: "Auth Proxy Diagnostics",
      extra: /* @__PURE__ */ s($, { children: [
        /* @__PURE__ */ e(X, { title: "Fetch via proxy", children: /* @__PURE__ */ e(
          B,
          {
            size: "small",
            icon: /* @__PURE__ */ e(ie, {}),
            loading: f,
            onClick: () => S(),
            children: "Proxy check"
          }
        ) }),
        g && /* @__PURE__ */ e(X, { title: "Fetch upstream IDP (cross-origin)", children: /* @__PURE__ */ e(
          B,
          {
            size: "small",
            icon: /* @__PURE__ */ e(ie, {}),
            loading: I,
            onClick: () => F(),
            children: "Upstream check"
          }
        ) }),
        /* @__PURE__ */ e(X, { title: "Open first-party auth endpoint", children: /* @__PURE__ */ e(
          B,
          {
            size: "small",
            icon: /* @__PURE__ */ e($e, {}),
            href: "/api/auth/csrf",
            target: "_blank",
            rel: "noreferrer noopener",
            children: "Open /api/auth/csrf"
          }
        ) })
      ] }),
      variant: "outlined",
      children: [
        /* @__PURE__ */ s($, { orientation: "vertical", size: "small", style: { width: "100%" }, children: [
          /* @__PURE__ */ s($, { wrap: !0, children: [
            /* @__PURE__ */ s(v, { color: "purple", children: [
              "Origin: ",
              x || "unknown"
            ] }),
            /* @__PURE__ */ s(v, { color: "blue", children: [
              "Upstream IDP: ",
              g || "not set"
            ] }),
            /* @__PURE__ */ s(v, { children: [
              "Audience: ",
              i
            ] }),
            /* @__PURE__ */ s(v, { color: typeof Z() == "string" ? "green" : "default", children: [
              "XSRF cookie now: ",
              typeof Z() == "string" ? "present" : "missing"
            ] })
          ] }),
          /* @__PURE__ */ s(ke, { type: "secondary", children: [
            "The proxy check calls ",
            /* @__PURE__ */ e("code", { children: "/api/auth/csrf" }),
            " on this origin with credentials. A healthy proxy returns 204 and issues the XSRF cookie scoped to this host."
          ] })
        ] }),
        /* @__PURE__ */ e(ue, { style: { margin: "12px 0" } }),
        j("Proxy response", u),
        g ? j("Direct upstream response", h) : null
      ]
    }
  );
}
function At(t) {
  const n = (t || "").replace(/\/$/, ""), o = n === "" ? "__SAME_ORIGIN__" : n;
  return [
    {
      name: "Aggregate",
      base: o,
      candidates: ["/api/health", "/health"]
    },
    {
      name: "Readiness",
      base: o,
      candidates: ["/api/health/ready", "/api/health/readiness", "/health/ready", "/health/readiness"]
    },
    {
      name: "Liveness",
      base: o,
      candidates: [
        "/api/health/live",
        "/api/health/liveness",
        "/health/live",
        "/health/liveness",
        "/live"
      ]
    }
  ];
}
function de() {
  try {
    const n = (typeof document < "u" ? document.cookie : "").split(";").map((o) => o.trim()).find((o) => o.startsWith("XSRF-TOKEN="));
    return n ? decodeURIComponent(n.split("=")[1] || "") : void 0;
  } catch {
    return;
  }
}
function It({ idpBase: t, audience: n, onApplied: o }) {
  const { message: i } = Te.useApp(), { token: p } = Pe.useToken(), c = (N, S) => je(i, N, S), { Text: u } = H, [y, h] = P("raw"), [m, f] = P(""), [D, I] = P(null), [O, x] = P(""), [g, w] = P(() => de());
  return /* @__PURE__ */ s(W, { title: "IDP Direct Login (Diagnostics)", style: { marginTop: 16 }, children: [
    /* @__PURE__ */ e(u, { type: "secondary", children: "Posts directly to the IDP login endpoint and shows the raw JSON response. Use this to validate credentials, audience, and token issuance without involving the app’s auth flow. Tokens are auto-applied on success." }),
    /* @__PURE__ */ e(ue, {}),
    /* @__PURE__ */ s("div", { style: { display: "flex", gap: 12, flexWrap: "wrap" }, children: [
      /* @__PURE__ */ e(G, { style: { maxWidth: 320 }, placeholder: "Email", type: "email", id: "diag-email" }),
      /* @__PURE__ */ e(G.Password, { style: { maxWidth: 240 }, placeholder: "Password", id: "diag-password" }),
      /* @__PURE__ */ e(xe, { id: "diag-remember" }),
      /* @__PURE__ */ e(u, { type: "secondary", children: "Remember" }),
      /* @__PURE__ */ s(v, { color: g ? "green" : "default", children: [
        "CSRF cookie: ",
        g ? "present" : "missing"
      ] }),
      /* @__PURE__ */ e(
        B,
        {
          size: "small",
          onClick: async () => {
            try {
              const N = _(t);
              N ? await fetch(`${N}/api/auth/csrf`, { credentials: "include" }) : await fetch("/api/auth/csrf", { credentials: "include" }), setTimeout(() => w(de()), 0), c("success", "Fetched CSRF token");
            } catch {
              c("warning", "Failed to fetch CSRF token");
            }
          },
          children: "Ensure CSRF cookie"
        }
      ),
      /* @__PURE__ */ e(
        B,
        {
          type: "primary",
          onClick: async () => {
            const N = _(t), S = document.getElementById("diag-email")?.value?.trim() || "", F = document.getElementById("diag-password")?.value || "", j = !!document.getElementById("diag-remember")?.checked;
            try {
              let T = 0, r = !1, d = null;
              const a = de(), k = `${N}/api/auth/login`, R = await fetch(k, {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                  "X-Client-Audience": n,
                  ...a ? { "X-XSRF-Token": a } : {}
                },
                body: JSON.stringify({ email: S, password: F })
              });
              T = R.status, r = R.ok;
              const b = await R.text();
              try {
                d = b ? JSON.parse(b) : null;
              } catch {
                d = { raw: b };
              }
              const E = JSON.stringify(
                { status: T, ok: r, audience: n, endpoint: k, body: d },
                null,
                2
              );
              if (x(E), I({ status: T, ok: r, audience: n, endpoint: k, body: d }), r && d && typeof d == "object") {
                const z = d, l = typeof z.accessToken == "string" ? z.accessToken : void 0, A = typeof z.refreshToken == "string" ? z.refreshToken : void 0, C = typeof z.jti == "string" ? z.jti : void 0;
                l ? (Y.getState().login(l, A, C, j), c("success", "Login successful • tokens applied"), o?.()) : z.mfaRequired === !0 && c("info", "MFA required — complete MFA flow to proceed");
              }
              w(de());
            } catch (T) {
              x(String(T));
            }
          },
          children: "Run login"
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { style: { marginTop: 12 }, children: /* @__PURE__ */ e(
      he,
      {
        size: "small",
        items: [
          {
            key: "raw-json",
            label: "Raw JSON (click to expand)",
            children: /* @__PURE__ */ s("div", { children: [
              /* @__PURE__ */ e("div", { style: { display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }, children: /* @__PURE__ */ s($, { children: [
                /* @__PURE__ */ e(B, { size: "small", onClick: () => h("raw"), children: "Raw" }),
                /* @__PURE__ */ e(B, { size: "small", onClick: () => h("tree"), children: "Tree" }),
                y === "tree" && /* @__PURE__ */ e(
                  G,
                  {
                    placeholder: "Search keys",
                    size: "small",
                    style: { maxWidth: 240 },
                    value: m,
                    onChange: (N) => f(N.target.value)
                  }
                )
              ] }) }),
              y === "raw" ? /* @__PURE__ */ e(
                G.TextArea,
                {
                  id: "diag-output",
                  value: O,
                  style: {
                    width: "100%",
                    minHeight: 240,
                    backgroundColor: p.colorBgContainer,
                    color: p.colorText,
                    borderColor: p.colorBorder
                  },
                  readOnly: !0
                }
              ) : D ? /* @__PURE__ */ e(
                "div",
                {
                  style: {
                    maxHeight: 360,
                    overflow: "auto",
                    border: `1px solid ${p.colorBorder}`,
                    borderRadius: 6,
                    padding: 8,
                    backgroundColor: p.colorBgContainer,
                    color: p.colorText
                  },
                  children: /* @__PURE__ */ e("pre", { style: { margin: 0, color: "inherit" }, children: JSON.stringify(D, null, 2) })
                }
              ) : /* @__PURE__ */ e(se, { type: "info", message: "Run login to populate JSON view" })
            ] })
          }
        ]
      }
    ) })
  ] });
}
function ee() {
  try {
    const n = (typeof document < "u" ? document.cookie : "").split(";").map((o) => o.trim()).find((o) => o.startsWith("XSRF-TOKEN="));
    return n ? decodeURIComponent(n.split("=")[1] || "") : void 0;
  } catch {
    return;
  }
}
function Ot({ idpBase: t, apiBase: n, audience: o = "teetime-admin" }) {
  const { message: i, notification: p } = Te.useApp(), { token: c } = Pe.useToken(), u = (l, A) => je(i, l, A), y = (l, A, C) => Fe(p, l, A, C), { Text: h } = H, m = Y.getState(), { login: f, loading: D } = _e(), [I, O] = P(""), [x, g] = P(""), [w, N] = P(!0), [S, F] = P("raw"), [j, T] = P(null), [r, d] = P(!1), a = U(() => _(t || ""), [t]), k = U(() => _(n || ""), [n]), [R, b] = P(() => ee()), E = async () => {
    try {
      a ? await fetch(`${a}/api/auth/csrf`, { credentials: "include", cache: "no-store" }) : await fetch("/api/auth/csrf", { credentials: "include", cache: "no-store" }), setTimeout(() => b(ee()), 120), u("success", "Fetched CSRF token");
    } catch {
      u("warning", "Failed to fetch CSRF token");
    }
  }, z = (l, A, C) => l === 201 || l === 200 ? { severity: "success", summary: `${l} · login succeeded` } : l === 204 ? { severity: "warning", summary: "204 · unexpected response", hint: "Auth proxy should return 200/201. Check IDP logs for additional details." } : l === 403 ? { severity: "error", summary: "403 · CSRF or audience rejected", hint: A ? "Audience or credentials rejected by IDP." : "Missing XSRF token. Ensure /api/auth/csrf succeeded through the proxy." } : l === 401 ? { severity: "warning", summary: "401 · invalid credentials", hint: "Verify email/password and audience header." } : l >= 500 ? { severity: "error", summary: `${l} · upstream error`, hint: "IDP returned 5xx. Check proxy target and upstream health." } : { severity: "warning", summary: `${l} · unexpected status`, hint: `Inspect ${C} response body for details.` };
  return /* @__PURE__ */ s(W, { title: "App Login Flow (Diagnostics)", style: { marginTop: 16 }, children: [
    /* @__PURE__ */ e(h, { type: "secondary", children: "Uses the app's configured IDP client hooks to exercise the standard login and refresh logic, then applies tokens into the app store when requested." }),
    /* @__PURE__ */ e(ue, {}),
    /* @__PURE__ */ s($, { wrap: !0, size: "middle", children: [
      /* @__PURE__ */ s(v, { color: "purple", children: [
        "IDP: ",
        a || "not set"
      ] }),
      /* @__PURE__ */ s(v, { color: "geekblue", children: [
        "API: ",
        k || "not set"
      ] }),
      /* @__PURE__ */ s(v, { children: [
        "Audience: ",
        o
      ] }),
      /* @__PURE__ */ s(v, { children: [
        "Store access: ",
        m.token ? "present" : "—"
      ] }),
      /* @__PURE__ */ s(v, { color: R ? "green" : "default", children: [
        "CSRF cookie: ",
        R ? "present" : "missing"
      ] }),
      /* @__PURE__ */ e(B, { size: "small", onClick: E, children: "Ensure CSRF cookie" })
    ] }),
    /* @__PURE__ */ s("div", { style: { display: "flex", gap: 12, flexWrap: "wrap", marginTop: 12 }, children: [
      /* @__PURE__ */ e(G, { style: { maxWidth: 320 }, placeholder: "Email", type: "email", value: I, onChange: (l) => O(l.target.value) }),
      /* @__PURE__ */ e(G.Password, { style: { maxWidth: 240 }, placeholder: "Password", value: x, onChange: (l) => g(l.target.value) }),
      /* @__PURE__ */ e(xe, { checked: w, onChange: N }),
      /* @__PURE__ */ e(h, { type: "secondary", children: "Remember" }),
      /* @__PURE__ */ e(
        B,
        {
          type: "primary",
          loading: r || D,
          onClick: async () => {
            d(!0);
            try {
              const l = await f({ email: I, password: x, remember: w }), A = `${a || ""}/api/auth/login`, C = ee(), { severity: J, summary: M, hint: K } = z(
                "accessToken" in l ? 200 : "mfaRequired" in l ? 202 : 200,
                typeof C == "string",
                A
              );
              T({ status: 200, ok: !0, endpoint: A, body: l }), y(J, M, K);
            } catch (l) {
              const A = document.getElementById("login-flow-output"), C = String(l?.message || l);
              A && (A.value = C);
              const J = l, M = J?.response?.status ?? 0, K = `${a || ""}/api/auth/login`, { severity: ae, summary: ce, hint: le } = z(M, typeof ee() == "string", K);
              T({ status: M, ok: !1, endpoint: K, body: J?.response?.data, error: C }), y(ae, ce, le ?? C), u("error", "Login failed");
            } finally {
              setTimeout(() => b(ee()), 0), d(!1);
            }
          },
          children: "Run login (app client)"
        }
      ),
      /* @__PURE__ */ e(
        B,
        {
          loading: r,
          onClick: async () => {
            d(!0);
            try {
              const l = Y.getState().refreshToken, A = Y.getState().jti;
              let C = 0, J = !1, M = null, K, ae, ce;
              const le = ee(), fe = {
                Accept: "application/json",
                "X-Client-Audience": o,
                ...le ? { "X-XSRF-Token": le } : {}
              }, Se = !!(l && A);
              Se && (fe["Content-Type"] = "application/json");
              const ye = await fetch(`${a || ""}/api/auth/refresh`, {
                method: "POST",
                credentials: "include",
                headers: fe,
                ...Se ? { body: JSON.stringify({ refreshToken: l, jti: A }) } : {}
              });
              C = ye.status, J = ye.ok;
              const me = await ye.text();
              try {
                const V = me ? JSON.parse(me) : null;
                M = V, J && V && typeof V == "object" && (K = V.accessToken, ae = V.refreshToken, ce = V.jti);
              } catch {
                M = { raw: me };
              }
              try {
                J && K && Y.getState().login(K, ae, ce, w);
              } catch (V) {
              }
              const Ee = JSON.stringify({ status: C, ok: J, endpoint: `${a || ""}/api/auth/refresh`, body: M }, null, 2), Ce = document.getElementById("login-flow-output");
              Ce && (Ce.value = Ee), T({ status: C, ok: J, endpoint: `${a || ""}/api/auth/refresh`, body: M });
            } catch (l) {
              const A = document.getElementById("login-flow-output"), C = String(l?.message || l);
              A && (A.value = C), T({ error: C }), u("error", "Refresh failed");
            } finally {
              d(!1);
            }
          },
          children: "Run refresh (app client)"
        }
      ),
      k && o === "teetime-admin" && /* @__PURE__ */ e(
        B,
        {
          onClick: async () => {
            if (!k || !Y.getState().token) {
              u("warning", "Requires API base and login token");
              return;
            }
            try {
              const l = await fetch(`${k}/admin/clubs?take=1`, {
                headers: { Accept: "application/json", Authorization: `Bearer ${Y.getState().token}` }
              }), A = await l.text();
              let C = null;
              try {
                C = A ? JSON.parse(A) : null;
              } catch {
                C = { raw: A };
              }
              const J = JSON.stringify({ status: l.status, ok: l.ok, endpoint: `${k}/admin/clubs?take=1`, body: C }, null, 2), M = document.getElementById("login-flow-output");
              M && (M.value = J), T({ status: l.status, ok: l.ok, endpoint: `${k}/admin/clubs?take=1`, body: C }), u(l.ok ? "success" : "warning", l.ok ? "Protected call OK" : `Protected call HTTP ${l.status}`);
            } catch (l) {
              const A = document.getElementById("login-flow-output"), C = String(l?.message || l);
              A && (A.value = C), T({ error: C }), u("error", "Protected call failed");
            }
          },
          children: "Test protected call (/admin/clubs)"
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e(ue, { style: { margin: "8px 0" } }),
      /* @__PURE__ */ s("div", { style: { display: "flex", gap: 8, alignItems: "center" }, children: [
        /* @__PURE__ */ e(Xe, { options: [{ label: "Raw", value: "raw" }, { label: "Tree", value: "tree" }], value: S, onChange: (l) => F(l) }),
        /* @__PURE__ */ e(B, { size: "small", icon: /* @__PURE__ */ e(pe, {}), onClick: async () => {
          try {
            const l = S === "raw" ? document.getElementById("login-flow-output")?.value ?? "" : j ? JSON.stringify(j, null, 2) : "";
            if (!l) return;
            await navigator.clipboard.writeText(l);
          } catch (l) {
            console.warn("Copy failed", l?.message);
          }
        }, children: "Copy results" })
      ] }),
      S === "raw" ? /* @__PURE__ */ e(
        G.TextArea,
        {
          id: "login-flow-output",
          style: {
            width: "100%",
            minHeight: 240,
            backgroundColor: c.colorBgContainer,
            color: c.colorText,
            borderColor: c.colorBorder
          },
          readOnly: !0
        }
      ) : j ? /* @__PURE__ */ e(
        "div",
        {
          style: {
            maxHeight: 360,
            overflow: "auto",
            border: `1px solid ${c.colorBorder}`,
            borderRadius: 6,
            padding: 8,
            marginTop: 8,
            backgroundColor: c.colorBgContainer,
            color: c.colorText
          },
          children: /* @__PURE__ */ e("pre", { style: { margin: 0, color: "inherit" }, children: JSON.stringify(j, null, 2) })
        }
      ) : /* @__PURE__ */ e(se, { type: "info", message: "Run login or refresh to populate JSON view" })
    ] })
  ] });
}
const { Title: rt, Text: be } = H, ot = [
  "/api/health/ready",
  "/api/health/readiness",
  "/api/health/live",
  "/api/health/liveness",
  "/health"
];
function Pt({
  title: t = "Readiness",
  base: n,
  candidates: o
}) {
  const [i, p] = Q.useState(null), [c, u] = Q.useState(!1), [y, h] = Q.useState(), m = Q.useMemo(
    () => o ? [...o] : ot,
    [o]
  ), f = Q.useCallback(async () => {
    u(!0);
    try {
      const F = (n || "").replace(/\/$/, "");
      for (const j of m) {
        const T = `${F}${j}`;
        try {
          const r = await fetch(T, { headers: { Accept: "application/json" }, cache: "no-store" });
          if (!r.ok) continue;
          const d = await r.text();
          if (!d) continue;
          try {
            const a = JSON.parse(d);
            p(a), h(T);
            break;
          } catch {
          }
        } catch {
        }
      }
    } finally {
      u(!1);
    }
  }, [n, m]);
  Q.useEffect(() => {
    f();
  }, [f]);
  const D = i, I = D && typeof D == "object" && !Array.isArray(D), O = I && D?.status || void 0, x = I && (D?.details || D?.info) || {}, g = Object.entries(x).filter(([, F]) => F && typeof F == "object"), w = g.filter(([, F]) => F?.status === "up").length, N = g.filter(([, F]) => F?.status === "down").length;
  return /* @__PURE__ */ s(
    W,
    {
      title: /* @__PURE__ */ s($, { children: [
        /* @__PURE__ */ e(rt, { level: 4, style: { margin: 0 }, children: t }),
        /* @__PURE__ */ e(v, { color: O === "ok" ? "green" : O === "error" ? "red" : "default", children: O ?? "unknown" }),
        /* @__PURE__ */ e(X, { title: "Aggregated component status from readiness endpoint", children: /* @__PURE__ */ e(Ue, {}) })
      ] }),
      extra: /* @__PURE__ */ s($, { children: [
        /* @__PURE__ */ e(X, { title: "Copy readiness JSON", children: /* @__PURE__ */ e(
          B,
          {
            size: "small",
            icon: /* @__PURE__ */ e(pe, {}),
            onClick: () => navigator.clipboard.writeText(JSON.stringify(i ?? {}, null, 2)),
            children: "Copy JSON"
          }
        ) }),
        /* @__PURE__ */ e(X, { title: "Refetch readiness", children: /* @__PURE__ */ e(B, { size: "small", icon: /* @__PURE__ */ e(ie, {}), loading: c, onClick: () => f(), children: "Refresh" }) })
      ] }),
      variant: "outlined",
      style: { marginTop: 12 },
      children: [
        g.length > 0 ? /* @__PURE__ */ s(Be, { children: [
          /* @__PURE__ */ s($, { size: 12, style: { marginBottom: 12 }, children: [
            /* @__PURE__ */ s(v, { color: "green", children: [
              "up: ",
              w
            ] }),
            /* @__PURE__ */ s(v, { color: N > 0 ? "red" : "default", children: [
              "down: ",
              N
            ] })
          ] }),
          /* @__PURE__ */ e("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 12 }, children: g.map(([F, j]) => {
            const T = j, r = T?.status, d = T?.latencyMs;
            return /* @__PURE__ */ e(W, { size: "small", variant: "outlined", children: /* @__PURE__ */ s($, { orientation: "vertical", size: 4, style: { width: "100%" }, children: [
              /* @__PURE__ */ s($, { children: [
                /* @__PURE__ */ e(be, { strong: !0, children: F }),
                /* @__PURE__ */ e(v, { color: r === "up" ? "green" : r === "down" ? "red" : "default", children: r ?? "unknown" })
              ] }),
              /* @__PURE__ */ e($, { size: 8, wrap: !0, children: typeof d == "number" && /* @__PURE__ */ s(v, { children: [
                d,
                "ms"
              ] }) })
            ] }) }, F);
          }) })
        ] }) : /* @__PURE__ */ e(be, { type: "secondary", children: "No component details provided by readiness endpoint." }),
        /* @__PURE__ */ e(
          he,
          {
            defaultActiveKey: [],
            items: [
              {
                key: "readiness-raw",
                label: "Readiness JSON",
                extra: y ? /* @__PURE__ */ s(be, { type: "secondary", children: [
                  "from ",
                  y
                ] }) : void 0,
                children: /* @__PURE__ */ e("pre", { style: { maxHeight: 320, overflow: "auto", margin: 0 }, children: JSON.stringify(i ?? {}, null, 2) })
              }
            ],
            style: { marginTop: 12 }
          }
        )
      ]
    }
  );
}
function st(t) {
  const n = new Set(t.map((i) => (i || "").toString())), o = ["SYSTEM_ADMIN", "OWNER", "platform.superadmin"];
  for (const i of o) if (n.has(i)) return !0;
  return t.some((i) => /(^|\.)admin$/i.test(i));
}
function $t(t) {
  const { routes: n, accessControlBase: o, auth: i, title: p = "Route Access Diagnostics", hasBypass: c } = t, u = U(() => {
    try {
      const m = i.token || "";
      if (!m) return !1;
      const f = We(m), D = Array.isArray(f?.roles) ? (f?.roles).filter((I) => typeof I == "string") : [];
      return (c ?? st)(D);
    } catch {
      return !1;
    }
  }, [i.token, c]);
  return /* @__PURE__ */ e(
    tt,
    {
      title: p,
      routes: n,
      auth: i,
      loadTenants: async () => {
        if (!o || !i.token) return [];
        try {
          const m = await fetch(`${o.replace(/\/$/, "")}/api/tenants`, {
            headers: { Authorization: `Bearer ${i.token}`, Accept: "application/json" }
          });
          if (!m.ok) return [];
          const f = await m.json();
          return Array.isArray(f) ? f : [];
        } catch {
          return [];
        }
      },
      checkCapability: async (m, f) => {
        const D = m.protected ? !!i.isAuthenticated : !0;
        if (!m.feature || !m.action)
          return u ? { capability: "Allowed (bypass)", accessible: !0 } : { capability: "—", accessible: D };
        if (!o || !f.token)
          return u ? { capability: "Allowed (bypass)", accessible: !0 } : { capability: "Denied", accessible: !1, note: o ? "missing token" : "missing base" };
        const I = o.replace(/\/$/, "");
        try {
          const O = await fetch(`${I}/api/capabilities/can`, {
            method: "POST",
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${f.token}`,
              ...f.tenantId ? { "x-tenant-id": f.tenantId } : {},
              Accept: "application/json"
            },
            body: JSON.stringify({ checks: [{ feature: m.feature, action: m.action }] })
          });
          if (!O.ok) {
            const g = await fetch(`${I}/api/capabilities/can`, {
              method: "POST",
              headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${f.token}`,
                ...f.tenantId ? { "x-tenant-id": f.tenantId } : {},
                Accept: "application/json"
              },
              body: JSON.stringify({ feature: m.feature, action: m.action, tenantId: f.tenantId })
            });
            if (!g.ok)
              return g.status >= 500 && u ? { capability: "Allowed (bypass)", accessible: !0, note: `HTTP ${g.status}` } : { capability: "Denied", accessible: !1, note: `HTTP ${g.status}` };
            const w = await g.text();
            try {
              const N = w ? JSON.parse(w) : {};
              if (typeof N.allowed == "boolean") {
                const S = N.allowed ? u ? "Allowed (bypass)" : "Allowed" : "Denied", F = m.protected ? !!N.allowed : !0;
                return { capability: S, accessible: F };
              }
            } catch {
            }
            return u ? { capability: "Allowed (bypass)", accessible: !0, note: "no result" } : { capability: "Denied", accessible: !1, note: "no result" };
          }
          const x = await O.text();
          try {
            const g = x ? JSON.parse(x) : {}, w = Array.isArray(g?.results) ? g.results[0] : void 0;
            if (w && typeof w.allowed == "boolean") {
              const N = w.allowed ? w.reason === "bypass" || u ? "Allowed (bypass)" : "Allowed" : "Denied", S = m.protected ? !!w.allowed : !0;
              return { capability: N, accessible: S };
            }
          } catch {
          }
          return u ? { capability: "Allowed (bypass)", accessible: !0, note: "no result" } : { capability: "Denied", accessible: !1, note: "no result" };
        } catch (O) {
          return u ? { capability: "Allowed (bypass)", accessible: !0, note: "fallback bypass" } : { capability: "Denied", accessible: !1, note: O?.message || "error" };
        }
      },
      resolveRoute: (m) => ({ ok: !0, url: m.path, missing: [] })
    }
  );
}
const { Text: ne, Paragraph: it, Title: at } = H, ct = {
  report: null,
  error: null,
  loading: !1,
  lastRun: null
};
function lt(t) {
  return t ? new Date(t).toLocaleTimeString() : "never";
}
function ze(t) {
  if (!t) return;
  const n = typeof t.bodyJson == "object" && t.bodyJson !== null ? t.bodyJson : void 0;
  if (n)
    for (const o of ["ip", "clientIp", "requestIp", "ipAddress"]) {
      const i = n[o];
      if (typeof i == "string" && i.trim())
        return i.trim();
    }
}
function dt(t) {
  const o = (t?.headers?.["x-forwarded-for"] ?? t?.headers?.["x-real-ip"])?.split(",")[0]?.trim(), i = ze(t);
  return !o || !i ? { forwardedFor: o, detectedIp: i, verdict: "missing" } : o === i ? { forwardedFor: o, detectedIp: i, verdict: "match" } : { forwardedFor: o, detectedIp: i, verdict: "mismatch" };
}
function ut(t) {
  return t.length ? /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ e(ne, { strong: !0, children: "Attempts" }),
    /* @__PURE__ */ e(
      "div",
      {
        role: "list",
        style: { display: "flex", flexDirection: "column", gap: 8, marginTop: 8 },
        children: t.map((n) => /* @__PURE__ */ e(
          "div",
          {
            role: "listitem",
            style: {
              border: "1px solid currentColor",
              borderRadius: 6,
              padding: 12,
              opacity: 0.8
            },
            children: /* @__PURE__ */ s($, { orientation: "vertical", size: 0, style: { width: "100%" }, children: [
              /* @__PURE__ */ s($, { wrap: !0, children: [
                /* @__PURE__ */ e(v, { color: n.ok ? "green" : "red", children: n.ok ? "OK" : "FAIL" }),
                /* @__PURE__ */ e(ne, { strong: !0, children: n.endpoint }),
                /* @__PURE__ */ e(ne, { type: "secondary", children: n.status ? `${n.status} ${n.statusText}` : "No response" })
              ] }),
              n.errorMessage ? /* @__PURE__ */ e(ne, { type: "secondary", style: { fontSize: 12 }, children: n.errorMessage }) : null
            ] })
          },
          `${n.endpoint}-${n.status}-${n.statusText}`
        ))
      }
    )
  ] }) : null;
}
function ht(t) {
  const n = t.data, o = n && typeof n == "object" && "countryIso" in n ? n : void 0, i = n ? `${n.latitude?.toFixed?.(4) ?? n.latitude}, ${n.longitude?.toFixed?.(4) ?? n.longitude}` : "—", p = ze(t), c = [];
  t.bodyJson !== void 0 ? c.push({ key: "body-json", header: "Response JSON", data: t.bodyJson }) : t.bodyText && c.push({ key: "body-text", header: "Response body", data: t.bodyText });
  const u = Object.entries(t.headers ?? {});
  return u.length && c.push({ key: "headers", header: "Response headers", data: Object.fromEntries(u) }), /* @__PURE__ */ s($, { orientation: "vertical", size: "small", style: { width: "100%" }, children: [
    /* @__PURE__ */ s(q, { size: "small", column: 1, bordered: !0, children: [
      /* @__PURE__ */ e(q.Item, { label: "Endpoint", children: t.endpoint }),
      /* @__PURE__ */ s(q.Item, { label: "Status", children: [
        t.status,
        " ",
        t.statusText
      ] }),
      /* @__PURE__ */ e(q.Item, { label: "Coordinates", children: i }),
      /* @__PURE__ */ e(q.Item, { label: "Detected IP", children: p ?? "—" }),
      o?.countryIso ? /* @__PURE__ */ e(q.Item, { label: "Country", children: o.countryIso }) : null,
      o?.city ? /* @__PURE__ */ e(q.Item, { label: "City", children: o.city }) : null,
      typeof o?.accuracyRadius == "number" ? /* @__PURE__ */ s(q.Item, { label: "Accuracy radius", children: [
        o.accuracyRadius,
        " km"
      ] }) : null
    ] }),
    /* @__PURE__ */ e(Ne, { sections: c })
  ] });
}
function pt(t) {
  switch (t.verdict) {
    case "match":
      return {
        color: "green",
        label: "Forwarded IP matches API detection",
        hint: t.forwardedFor ?? "—"
      };
    case "mismatch":
      return {
        color: "orange",
        label: "Forwarded IP differs from API detection",
        hint: `${t.forwardedFor ?? "—"} → ${t.detectedIp ?? "—"}`
      };
    default:
      return {
        color: "gold",
        label: "Missing IP metadata",
        hint: "Forwarded or detected IP not present in response headers/body."
      };
  }
}
function Dt({ apiBase: t, className: n }) {
  const [o, i] = P(ct), p = re(null), c = re(!0), u = U(() => _(t || ""), [t]), y = oe(async () => {
    p.current?.abort();
    const g = new AbortController();
    p.current = g, i((w) => ({ ...w, loading: !0, error: null }));
    try {
      u ? Re(u) : Re(void 0);
      const w = await He(g.signal);
      if (!c.current || g.signal.aborted) return;
      i({ report: w, error: null, loading: !1, lastRun: Date.now() });
    } catch (w) {
      if (!c.current || g.signal.aborted) return;
      const N = w instanceof Error ? w.message : String(w);
      i({ report: null, error: N, loading: !1, lastRun: Date.now() });
    } finally {
      p.current === g && (p.current = null);
    }
  }, [u]);
  L(() => (y(), () => {
    c.current = !1, p.current?.abort();
  }), [y]);
  const { report: h, error: m, loading: f, lastRun: D } = o, I = h?.final, O = dt(I), x = pt(O);
  return /* @__PURE__ */ e(
    W,
    {
      className: n,
      title: "Geo Diagnostics",
      extra: /* @__PURE__ */ s($, { children: [
        /* @__PURE__ */ s(v, { color: u ? "blue" : "default", children: [
          "Base: ",
          u || "proxy origin"
        ] }),
        /* @__PURE__ */ e(B, { icon: /* @__PURE__ */ e(ie, {}), onClick: y, disabled: f, loading: f, children: "Refresh" })
      ] }),
      children: /* @__PURE__ */ s($, { orientation: "vertical", size: "middle", style: { width: "100%" }, children: [
        /* @__PURE__ */ s($, { orientation: "vertical", size: 2, children: [
          /* @__PURE__ */ e(at, { level: 5, style: { marginBottom: 0 }, children: "Validate proxy → TeeTime API GeoIP chain" }),
          /* @__PURE__ */ e(it, { type: "secondary", style: { marginBottom: 0 }, children: "Runs `/api/ip-location/details` with fallback to `/api/ip-location` to confirm that the proxy forwards the correct client IP and the TeeTime API returns enriched GeoIP metadata." }),
          /* @__PURE__ */ s(ne, { type: "secondary", children: [
            "Last run: ",
            lt(D)
          ] })
        ] }),
        /* @__PURE__ */ e(v, { color: x.color, children: x.label }),
        /* @__PURE__ */ e(ne, { type: "secondary", children: x.hint }),
        m ? /* @__PURE__ */ e(se, { type: "error", showIcon: !0, message: "Geo diagnostics failed", description: m }) : null,
        I ? /* @__PURE__ */ s($, { orientation: "vertical", size: "small", style: { width: "100%" }, children: [
          /* @__PURE__ */ s($, { wrap: !0, children: [
            /* @__PURE__ */ e(v, { color: I.ok ? "green" : "red", children: I.ok ? "OK" : "ERROR" }),
            /* @__PURE__ */ s(v, { children: [
              I.status,
              " ",
              I.statusText
            ] }),
            /* @__PURE__ */ e(v, { color: "purple", children: I.endpoint })
          ] }),
          I.ok ? ht(I) : /* @__PURE__ */ e(
            se,
            {
              type: "warning",
              showIcon: !0,
              message: "Final attempt failed",
              description: I.errorMessage || "Unexpected error"
            }
          )
        ] }) : null,
        h?.attempts ? ut(h.attempts) : null
      ] })
    }
  );
}
export {
  $t as AccessControlRouteAccessPanel,
  Tt as AudienceSelector,
  Rt as AuthProxyDiagnosticsPanel,
  xt as EndpointStatusCard,
  Dt as GeoDiagnosticsPanel,
  It as IdpDiagnosticsPanel,
  Ne as JsonDetailsCollapse,
  Ot as LoginFlowDiagnosticsPanel,
  St as OverridesForm,
  Ct as ProbesPanel,
  Pt as ReadinessPanel,
  tt as RouteAccessDiagnosticsPanel,
  qe as StatusPill,
  _ as normalizeBase,
  At as standardBackendProbes,
  Ve as useOverridesState,
  De as useTryFetch
};
//# sourceMappingURL=index.js.map
